import { useContext } from 'react'
import { type SnackbarProps } from './Snackbar'
import { SnackbarContext, type SnackbarContextProps } from './SnackbarProvider'

export const useSnackbar = <Props extends SnackbarProps = SnackbarProps>() => {
  const context = useContext<SnackbarContextProps<Props> | null>(SnackbarContext)

  if (!context) {
    throw new Error('useSnackbar must be used within an SnackbarProvider')
  }

  return context
}
